var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stran-brez-izbirnika pregled-vsebine"},[_c('div',{staticStyle:{"clear":"both"}}),_vm._v(" "),_c('div',{staticClass:"vsebina-postavitev"},[_c('div',{staticClass:"odmik-vsebine"},[_c('div',[_c('UporabneStraniPovezave')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97194b36","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/UporabniskiKoticek/UporabneStrani.vue
// module id = Fgd9
// module chunks = 3